import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(3),
    paddingTop: '103px',
    maxWidth: '1200px',
    margin: '0 auto',
    minHeight: '100vh',
    backgroundColor: STYLE.COLOR.WHITE,
    '@media (max-width: 1024px)': {
      paddingTop: '100px',
      maxWidth: '100%',
      padding: theme.spacing(2),
    },
    '@media (max-width: 768px)': {
      paddingTop: '90px',
      padding: theme.spacing(2),
    },
    '@media (max-width: 600px)': {
      paddingTop: '80px',
    },
    '@media (max-width: 480px)': {
      padding: theme.spacing(2),
      paddingTop: '90px',
    },
  },
  containerWithWarning: {
    paddingTop: '143px',
    '@media (max-width: 1024px)': {
      paddingTop: '140px',
    },
    '@media (max-width: 768px)': {
      paddingTop: '130px',
    },
    '@media (max-width: 600px)': {
      paddingTop: '120px',
    },
    '@media (max-width: 480px)': {
      paddingTop: '130px',
    },
  },
  mainHeader: { left: 0 },

  // Header styles
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    '@media (max-width: 768px)': {
      marginBottom: theme.spacing(3),
    },
  },
  title: {
    fontWeight: 600,
    color: STYLE.COLOR.BLACK,
    fontSize: '32px',
    lineHeight: '39px',
    '@media (max-width: 768px)': {
      fontSize: '24px',
      lineHeight: '30px',
    },
    '@media (max-width: 480px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  headerActions: {
    display: 'flex',
    gap: theme.spacing(2),
    '@media (max-width: 768px)': {
      width: '100%',
      justifyContent: 'flex-start',
    },
    '@media (max-width: 480px)': {
      gap: theme.spacing(1.5),
    },
  },
  actionButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  actionButton: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textDecoration: 'underline',
    color: STYLE.COLOR.ACCENT_PRIMARY,
    cursor: 'pointer',
  },

  // Tabs styles
  tabsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '32px',
    gap: theme.spacing(2),
    '@media (max-width: 960px)': {
      marginBottom: theme.spacing(3),
    },
    '@media (max-width: 480px)': {
      gap: '10px',
    },
  },
  tabs: {
    borderBottom: '0px' + '!important',
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      color: STYLE.COLOR.TEXT1,
      '&.Mui-selected': {
        backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
        color: STYLE.COLOR.WHITE,
        '& .custom-count-badge': {
          backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
          color: STYLE.COLOR.ACCENT_PRIMARY,
        },
      },
      '@media (max-width: 768px)': {
        fontSize: '14px',
        minWidth: 'auto',
        padding: theme.spacing(1, 1.5),
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '@media (max-width: 768px)': {
      width: '100%',
      '& .MuiTabs-flexContainer': {
        justifyContent: 'flex-start',
      },
    },
    '@media (max-width: 480px)': {
      overflowX: 'auto',
      '& .MuiTabs-scroller': {
        overflowX: 'auto !important',
      },
    },
  },
  tab: {
    border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}` + '!important',
    borderRadius: '8px !important',
    marginRight: '16px' + '!important',
    '@media (max-width: 768px)': {
      marginRight: '8px' + '!important',
    },
    '@media (max-width: 480px)': {
      marginRight: '6px' + '!important',
    },
  },
  customTabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  customCountBadge: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    borderRadius: '50%',
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1,
  },
  sortButton: {
    width: '112px' + '!important',
    height: '52px' + '!important',
    opacity: 1,
    border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}` + '!important',
    borderRadius: '52px' + '!important',
    padding: '14px 24px' + '!important',
    fontSize: '16px' + '!important',
    fontWeight: 400 + '!important',
    lineHeight: '24px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    display: 'flex' + '!important',
    alignItems: 'center' + '!important',
    flexShrink: 0 + '!important',
    '@media (max-width: 960px)': {
      justifyContent: 'center !important',
      minWidth: '52px !important',
      padding: '0 !important',
      '& svg': {
        margin: 0 + '!important',
      },
    },
    '@media (max-width: 480px)': {
      height: '44px !important',
      width: '44px !important',
      minWidth: '44px !important',
      borderRadius: '12px' + '!important',
    },
  },

  // Courses grid
  coursesGrid: {
    marginTop: theme.spacing(2),
    '@media (max-width: 768px)': {
      '& > .MuiGrid-item': {
        paddingTop: '18px !important',
      },
    },
    '@media (max-width: 480px)': {
      '& > .MuiGrid-item': {
        paddingTop: '18px !important',
      },
    },
  },

  // Course card styles
  courseCard: {
    opacity: 1,
    borderRadius: '12px' + '!important',
    borderWidth: '1px',
    border: '1px solid #EAEAEA',
    boxShadow: '0 16px 20px -8px rgba(228, 231, 233, 0.40)' + '!important',
    padding: '16px 16px' + '!important',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 20px 24px -8px rgba(228, 231, 233, 0.50)' + '!important',
    },
  },
  courseCardExpired: {
    backgroundColor: STYLE.COLOR.DISABLED_BACKGROUND + '!important',
    cursor: 'not-allowed' + '!important',
    '&:hover': {
      transform: 'none' + '!important',
      boxShadow: '0 16px 20px -8px rgba(228, 231, 233, 0.40)' + '!important',
    },
  },

  // Course info styles
  courseInfo: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '12px',
  },
  courseHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  courseNameContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
  },
  arrowRightIcon: {
    '& path': {
      stroke: STYLE.COLOR.ACCENT_PRIMARY,
    },
  },
  courseAvatar: {
    backgroundColor: STYLE.COLOR.WARNING_LIGHT + '!important',
    color: STYLE.COLOR.TEXT4 + '!important',
    width: '40px',
    height: '40px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  courseName: {
    fontSize: '16px',
    fontWeight: 600,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    lineHeight: '24px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '@media (max-width: 768px)': {},
    '@media (max-width: 480px)': {},
  },
  courseNameExpired: {
    color: STYLE.COLOR.TEXT2 + '!important',
  },
  courseDetailsContainer: {
    borderTop: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    borderTopStyle: 'dashed',
    marginTop: '12px',
    paddingTop: '16px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  courseDetail: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '8px',
    fontSize: '14px',
    lineHeight: '20px',
  },
  courseDetailLabel: {
    color: STYLE.COLOR.TEXT2,
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 400,
  },
  courseDetailValue: {
    color: STYLE.COLOR.TEXT1,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '22px',
    marginTop: '4px',
  },
  courseDetailValueExpired: {
    color: STYLE.COLOR.ERROR + '!important',
  },
  statusContainer: {
    height: 22,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  courseStatusBadge: {
    fontSize: 10,
    fontWeight: 600,
    lineHeight: '16px',
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: '3px 8px',
    borderRadius: '4px',
  },
  progressContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  progressBar: {
    height: '8px' + '!important',
    borderRadius: '3px' + '!important',
    backgroundColor: STYLE.COLOR.GRAY + '!important',
    flex: 1,
  },
  progressBarFill: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY + '!important',
  },
  progressBarFillExpired: {
    backgroundColor: STYLE.COLOR.TEXT2 + '!important',
  },
  progressText: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '32px',
    color: STYLE.COLOR.ACCENT_PRIMARY,
    minWidth: '35px',
    textAlign: 'right',
  },
  progressTextExpired: {
    color: STYLE.COLOR.TEXT2 + '!important',
  },

  // Empty state styles
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8, 2),
    textAlign: 'center',
    minHeight: '400px',
  },
  emptyStateIcon: {
    fontSize: '64px',
    marginBottom: theme.spacing(2),
    opacity: 0.5,
  },
  emptyStateTitle: {
    fontWeight: 600,
    color: STYLE.COLOR.TEXT1,
    marginBottom: theme.spacing(1) + '!important',
  },
  emptyStateSubtitle: {
    color: STYLE.COLOR.TEXT2,
    maxWidth: '400px',
  },
  content: {
    paddingBottom: theme.spacing(2),
  },
  paginationWrapper: {
    padding: theme.spacing(2, 0),
    marginTop: '48px',
    marginBottom: '48px',
    '@media (max-width: 768px)': {
      marginTop: '32px',
      marginBottom: '32px',
    },
    '@media (max-width: 480px)': {
      marginTop: '24px',
      marginBottom: '24px',
      '& .MuiPagination-ul': {
        flexWrap: 'nowrap',
        justifyContent: 'center',
      },
    },
  },

  // Dropdown styles for mobile
  tabDropdown: {
    flex: 1 + '!important',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}` + '!important',
    borderRadius: '12px' + '!important',
    justifyContent: 'space-between' + '!important',
    padding: '14px 16px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    fontWeight: 500 + '!important',
    fontSize: '14px' + '!important',
    lineHeight: '100%' + '!important',
  },

  dropdownMenu: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      borderRadius: theme.spacing(1),
      minWidth: `calc(100% - 88px)`,
      padding: '0px 12px',
      marginTop: '8px',
    },
  },

  dropdownMenuItem: {
    fontSize: '14px' + '!important',
    fontWeight: 400,
    lineHeight: '20px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    minHeight: '36px' + '!important',
    paddingLeft: '8px' + '!important',
    '&:hover, &.Mui-selected': {
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT + '!important',
      borderRadius: theme.spacing(1) + '!important',
    },
    '& svg': {
      marginRight: '8px',
      fontSize: '18px',
      color: STYLE.COLOR.TEXT2,
      width: '18px',
      height: '18px',
    },
  },
  dropdownItemContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(1),
  },
  dropdownCountBadge: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    borderRadius: '50%',
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1,
  },

  // Sort Menu styles
  sortMenu: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}`,
      borderRadius: theme.spacing(1),
      minWidth: '200px',
      padding: '0px 12px',
      marginTop: '12px',
    },
  },
  menuItem: {
    padding: '8px 8px 8px 6px' + '!important',
    fontSize: '14px' + '!important',
    fontWeight: 400,
    lineHeight: '20px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    '&:hover, &.Mui-selected': {
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT + '!important',
      borderRadius: theme.spacing(1) + '!important',
    },
    '& svg': {
      marginRight: '8px',
      fontSize: '18px',
      color: STYLE.COLOR.TEXT2,
      width: '18px',
      height: '18px',
    },
  },

  // Loading and error state styles
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px',
  },
  errorContainer: {
    padding: '20px',
  },
}));
